<template>
  <div>
    <v-row>
      <v-col cols="10" class="d-flex align-center">
        <h2 class="text-subtitle-1 text-lg-subtitle-1 font-weight-bold">
          Certificate Signing Request (CSR)
        </h2>
        <div class="tooltip pl-1">
          <tooltip-component
            text=" Upload a CSR (PKCS#10) file or paste PEM formatted CSR into the input field.
                   Both PEM and DER encoded files are supported. Extensions supported: .p10, .csr, .pem and .txt."
          />
        </div>
      </v-col>
    </v-row>

    <!-- TODO: Check if global-radio-group can be used -->
    <!-- Move @click out from the radios -->
    <!-- maybe trigger method check for different value -->
    <v-row no-gutters>
      <v-col cols="12" md="12" xl="1">
        <div class="text-body-2 text-lg-body-2 mt-1 pb-2">Input method</div>
      </v-col>
      <v-radio-group
        :row="true ? $vuetify.breakpoint.mdAndUp : false"
        :cols="true ? $vuetify.breakpoint.smAndDown : false"
        v-model="radioGroupModal"
        class="mt-0"
        @click="uploadMethod"
        dense
      >
        <v-radio value="1" color="#006CA1" @click="uploadMethod">
          <template v-slot:label>
            <span class="text-body-2 text-lg-body-2 font-weight-regular">
              Upload file
            </span>
          </template>
        </v-radio>
        <v-radio value="2" color="#006CA1" @click="copyAndPasteMethod">
          <template v-slot:label>
            <span class="text-body-2 text-lg-body-2 font-weight-regular">
              Copy and paste
            </span>
          </template>
        </v-radio>
      </v-radio-group>
    </v-row>

    <!-- CSR file validation -->
    <v-row no-gutters class="text-right" v-if="(showUploadMethod && file) || invalidFile">
      <div style="display: flex; flex-direction: column; width: 100%">
        <div>
          <v-col cols="8">
            <v-btn
              depressed
              width="3.75em"
              x-small
              color="red--text white"
              @click="deleteButton"
              v-if="!cancelDeleteCSRDialog"
            >
              <v-icon color="red" small class="mr-2">fa-light fa-trash</v-icon>Delete
            </v-btn>
          </v-col>
        </div>

        <v-col cols="8" v-if="cancelDeleteCSRDialog" style="max-width:600px"
          ><v-app-bar rounded dense elevation="0" color="amber lighten-5" class="mb-2">
            <v-icon color="#F1B300" small class="mr-2"
              >fa-solid fa-triangle-exclamation</v-icon
            >
              <div
                  class="text-wrap" style="text-align: center">
                  Are you sure you would like to delete the uploaded file?
              </div>
          </v-app-bar>
          <v-btn text small @click="cancelDeleteDialogButton"> No</v-btn>
            <v-btn
              elevation="0"
              small
              color="red darken-3"
              class="white--text"
              @click="removeFile"
              >Yes</v-btn
            >
        </v-col>
      </div>
    </v-row>

    <!-- CSR file upload -->
    <slot name="fileUploadTemp"></slot>

    <!-- CSR file upload text -->
    <v-row v-if="showUploadMethod && !fileContent"
      ><v-col cols="12"
        ><div class="file-upload-required">
          <span>File upload is required.</span>
        </div>
      </v-col>
    </v-row>

    <!-- CSR file content -->
    <v-row no-gutters>
      <v-col cols="12">
        <div class="d-flex align-center">
          <div class="text-h7 mr-1 csr-file" v-if="!showText">Show CSR content</div>
          <div class="text-h7 mr-1 csr-file" v-if="showText">Hide CSR content</div>
          <v-btn icon v-if="showText" @click="dontShowText"
            ><v-icon small>fa-chevron-up</v-icon></v-btn
          >
          <v-btn icon v-if="!showText" @click="doShowText"
            ><v-icon small>fa-chevron-down</v-icon></v-btn
          >
        </div>
        <div style="display: flex; flex-direction: column; width: 100%">
          <div>
            <v-col
              class="text-right ml-4"
              style="width: 55%"
              v-if="showCopyAndPasteMethod && fileContent"
            >
              <v-btn
                depressed
                width="3.75em"
                x-small
                color="red--text white"
                @click="removeFile"
              >
                <v-icon color="red" small class="mr-2">fa-light fa-trash</v-icon>Delete
              </v-btn>
            </v-col>
          </div>
          <div style="display: flex; width: 75%">
            <slot name="csrContentForm"></slot>
            <v-icon v-if="showCopyAndPasteMethod" x-small color="red" class="pl-2"
              >fa-asterisk</v-icon
            >
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import globalRadioGroup from "@/components/global/global-radio-group.vue";
import tooltipComponent from "@/components/global/tooltip-component.vue";
export default {
  props: [
    "radioGroup",
    "showUploadMethod",
    "file",
    "invalidFile",
    "cancelDeleteCSRDialog",
    "fileContent",
    "showText",
    "showCopyAndPasteMethod",
    "valid",
  ],
  components: {
    globalRadioGroup,
    tooltipComponent,
  },
  computed: {
    radioGroupModal: {
      get: function () {
        return this.radioGroup;
      },
      set: function (newVal) {
        this.$emit("update:radioGroup", newVal);
      },
    },
  },
  methods: {
    uploadMethod() {
      this.$emit("uploadMethod");
    },
    copyAndPasteMethod() {
      this.$emit("copyAndPasteMethod");
    },
    deleteButton() {
      this.$emit("deleteButton");
    },
    cancelDeleteDialogButton() {
      this.$emit("cancelDeleteDialogButton");
    },
    removeFile() {
      this.$emit("removeFile");
    },
    dontShowText() {
      this.$emit("dontShowText");
    },
    doShowText() {
      this.$emit("doShowText");
    },
  },
};
</script>
<style scoped lang="scss">
.tooltip {
  vertical-align: top;
}
.fa-circle-question::before {
  vertical-align: top;
}
.csr-file {
  max-width: 120px;
}
</style>
